














































import { Vue, Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { lazyInject } from '@/app/container';
import { SearchResult, SearchService, SearchServiceSymbol,
         SearchResultItem, SearchResultPosition } from '@/app/search/search-service';
import { BreadcrumbService, BreadcrumbServiceSymbol } from '@/app/breadcrumb/breadcrumb-service';
import { UiSearchResultItem } from './ui-search-result-item';
import { getPageFromHref } from '@/app/shared/utils/route-utils';
import { getContainingChapter } from '@/app/aspect/toc-utils';
import { Link } from '@/app/shared/models';
import { setDocumentTitle } from '@/app/shared/utils/document-utils';
import WrapperCommonComponent from '@/app/shared/components/wrapper/wrapper-common-component.vue';
import SearchResultItemComponent from '@/app/search/components/search-result-item-component.vue';
import i18n from '@/plugins/i18n';
import { TranslateResult } from 'vue-i18n';


let prevRoute: Route|null = null;

@Component({
  components: {
    WrapperCommonComponent,
    SearchResultItemComponent
  },
  beforeRouteEnter(to: Route, from: Route, next) {
    prevRoute = from;
    next();
  }
})
export default class SearchPageComponent extends Vue {
  public results: SearchResultItem[] = []

  public query: string = '';

  public typing: boolean = false;
  public searched: boolean = false;
  public searching: boolean = false;


  @lazyInject(SearchServiceSymbol)
  private searchService: SearchService;

  @lazyInject(BreadcrumbServiceSymbol)
  private breadcrumbService: BreadcrumbService;

  private timeout: number|null = null;

  public get resultsCount(): number {
    return this.results.length
  }

  public get prevRoute() {
    if (prevRoute === null || prevRoute.name === null) {
      return { name: 'dashboard' };
    }

    return prevRoute;
  }

  public mounted(): void {
    if (this.$route.query.q) {
      this.query = this.$route.query.q as string;
      this.search();
    }

    (this.$refs.searchInput as any).focus();

    setDocumentTitle([
      i18n.t('player.search').toString()
    ]);
  }

  public debounceSearch(): void {
    this.typing = true;

    if (this.timeout !== null) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      this.query = this.query.trim();
      this.$router.push({ query: { q: this.query } });
      if (this.query !== '') {
        this.searching = true;
        this.search();
        this.searched = true;
        this.typing = false;
      }
    }, 500);
  }

  public markFragmentsAndSetBreadcrumb({ id, fields }: SearchResultItem): UiSearchResultItem {
    const href = id.replace(/#tmp_id=[\d]*/, '')

    const resultItem: UiSearchResultItem = {};
    if (fields.title) {
      resultItem.title = this.markFragment(fields.title.value, [ ...fields.title.positions ]);
    }

    if (fields.body) {
      resultItem.body = this.markFragment(fields.body.value, [ ...fields.body.positions ]);
    }

    let breadcrumbItems: Link[] = [];
    const tocResult = getContainingChapter(href);
    if (tocResult !== null) {
      const page = getPageFromHref(href);
      const breadcrumbItemsResult = this.breadcrumbService.createItems(page, tocResult.chapter);
      breadcrumbItems = [...breadcrumbItemsResult.links, {
        href: tocResult.item.href,
        title: tocResult.item.title
      }];
    }

    resultItem.breadcrumbItems = breadcrumbItems;

    return resultItem;
  }

  public t(key: string): TranslateResult {
    return i18n.t(key);
  }

  private async search() {
    this.results = (await this.searchService.search(this.query)).items;
    this.searching = false;
  }

  private markFragment(value: string, positions: Array<SearchResultPosition>): string {
    const highlight = (fragment: string) => `<span class="search-keyword">${fragment}</span>`;

    positions = this.reverseSortPositions(positions)

    for (const item of positions) {
      const fragment: string = value.substring(item.start, item.end);

      value = value.substring(0, item.start) + highlight(fragment) + value.substring(item.end);
    }

    return value;
  }

  private reverseSortPositions(positions: Array<SearchResultPosition>): Array<SearchResultPosition> {
    return positions.sort((a, b) => {
      if (a.start > b.start) return -1;
      if (a.start < b.start) return 1;
      return 0;
    })
  }
}
